export default import.meta.ROLLUP_FILE_URL__ho9qRY$T_Jz6gdXf7k7$A;